<div class="row filters-row" *ngIf="haveAnyFilters">
	<div class="col-md-10">
		<input
			type="text"
			class="form-control w-100"
			(keyup)="refreshFilter()"
			[(ngModel)]="filterValue"
			placeholder="Filtrowanie (min. 3 znaki)"
		/>
	</div>
	<div class="col-md-2 text-center">
		<button
			class="btn btn-secondary me-2"
			*ngIf="haveFilters"
			[ngClass]="{ 'btn-warning': filtersSet }"
			(click)="filersOpen()"
		>
			<i class="fas fa-filter"></i>
		</button>
		<button
			class="btn btn-secondary"
			[ngClass]="{ 'btn-warning': viewIsSet }"
			(click)="this.tableShowOptions = !this.tableShowOptions"
		>
			<i class="fas fa-eye"></i>
		</button>
	</div>
</div>

<div class="alert alert-warning text-center" *ngIf="!showElements.length">Brak wyników</div>

<div class="container text-center" *ngIf="tableShowOptions">
	<ul class="list-inline">
		<li class="list-inline-item" *ngFor="let item of tableRows">
			<button
				type="button"
				class="btn btn-primary"
				[ngClass]="{
					'btn-secondary': settings.hiddenColumns.includes(item.id),
				}"
				(click)="showHideRow(item.id)"
				*ngIf="item.name"
			>
				{{ item.name }}
			</button>
		</li>
	</ul>
</div>

<table class="table table-striped table-hover" *ngIf="showElements.length">
	<thead class="table-dark" *ngIf="showHeader">
		<tr>
			<th class="align-middle">LP</th>
			<th *ngFor="let row of showColumns" class="align-middle">
				<span (click)="setSort(row.id)" [ngClass]="{ sortBy: row.id === settings.sort.key }">
					{{ row.name }}
				</span>
			</th>
			<th class="haveLink" *ngIf="linkAccess && (haveLink || haveButton)">&nbsp;</th>
		</tr>
	</thead>
	<tbody>
		<tr
			*ngFor="let row of showElements; index as rowIndex"
			[ngStyle]="row?.style"
			[class]="row?.class"
			[id]="row.tableElementId"
		>
			<td [ngStyle]="row?.style">
				{{ (this.settings.currentPage - 1) * this.rowsPerPage + (rowIndex + 1) }}
			</td>
			<td *ngFor="let item of showColumns" [ngStyle]="row?.style">
				<span [innerHTML]="row[item.id]" *ngIf="!item.icon && !item.link"></span>
				<a
					[routerLink]="row[item.id].link"
					*ngIf="item.link && !row[item.id].external"
					[target]="item.target"
					>{{ row[item.id].label }}</a
				>
				<a [href]="row[item.id].link" *ngIf="item.link && row[item.id].external" [target]="item.target">{{
					row[item.id].label
				}}</a>
				<i [class]="row[item.id]" *ngIf="item.icon"></i>
			</td>
			<td
				class="text-end align-middle haveLink"
				*ngIf="linkAccess && (haveLink || haveButton)"
				[ngStyle]="row?.style"
			>
				<a class="btn btn-primary" routerLink="{{ row.link }}" *ngIf="haveLink">&gt;&gt;</a>
				<button
					class="btn btn-primary"
					(click)="onButtonClick(row)"
					*ngIf="haveButton"
					[innerHTML]="buttonText"
				></button>
			</td>
		</tr>
	</tbody>
</table>

<br />

<nav *ngIf="pages.count > 1">
	<ul class="pagination justify-content-center">
		<li class="page-item disabled">
			<span class="page-link">Strony</span>
		</li>
		<li class="page-item" *ngFor="let page of pages.pages" [ngClass]="{ disabled: page === settings.currentPage }">
			<span class="page-link" (click)="pageChange(page)">{{ page }}</span>
		</li>
	</ul>
</nav>
